import { createClient } from '@supabase/supabase-js';
import type { Database } from '../../../shared/src/types/database';

const supabaseUrl     = import.meta.env.VITE_SUPABASE_URL     as string;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY.\n' +
    'Add these to your web/.env file (copy from .env.example).'
  );
}

/**
 * Browser-side Supabase client.
 * Uses the anon key — safe to expose, Row Level Security enforces data isolation.
 * PKCE flow for OAuth (more secure than implicit — prevents token interception).
 *
 * detectSessionInUrl: false — AuthCallbackPage calls exchangeCodeForSession()
 * directly so we own the timing and get explicit success/failure handling.
 * Auto-detection races with the Web Lock and causes unpredictable delays.
 */
export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    flowType:           'pkce',
    detectSessionInUrl: false,
    persistSession:     true,
    autoRefreshToken:   true,
  },
});
